import { v4 } from 'uuid';

export const QUESTION_STATUS_TEXT = 'Status';
export const QUESTION_STATUS_ANSWERS = [
  { text: 'Good', id: v4() },
  { text: 'Bad', id: v4() },
];

export const QUESTION_ALTERNATIVE_TEXT = 'Untitled Question 1';
export const QUESTION_ALTERNATIVE_ANSWERS = [
  { text: 'Answer 1', id: v4() },
  { text: 'Answer 2', id: v4() },
];

export const MARKING_TOOL_NAME = 'Untitled Tool 1';
